// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__3pZe9","search":"Settings_search__SufHG","filter":"Settings_filter__3ZWuK"};